export const gpCharts = [
  {
    title: 'Percentage of Children with Incomplete Vaccination Schedule',
    ref: 'dynamicArrayV4',
    summary_search_parameter_for_charts: 'UptoDate=No',
    main_link_for_chart: '/vaccine-history?UptoDate=No',
    filters: [
      {
        total_text: 'Total registered',
        total: 'AgeGroup=0-5',
        value: 'AgeGroup=0-5&UptoDate=No',
        link: '/vaccine-history?AgeGroup=0-5&UptoDate=No',
        label: '0-5',
        custom_property_name_2: 'Age group',
        custom_property_value_2: '0-5',
        filtered_total_text: 'Missing Immunisations',
        filtered_total_value: '',
      },
      {
        total_text: 'Total registered',
        total: 'AgeGroup=6-19',
        value: 'AgeGroup=6-19&UptoDate=No',
        link: '/vaccine-history?AgeGroup=6-19&UptoDate=No',
        label: '6-19',
        custom_property_name_2: 'Age group',
        custom_property_value_2: '6-19',
        filtered_total_text: 'Missing Immunisations',
        filtered_total_value: '',
      },
    ],
  },
  {
    title: 'Percentage of Children with No Vaccinations Recorded',
    ref: 'dynamicArrayV4',
    summary_search_parameter_for_charts: 'UptoDate=No Record',
    main_link_for_chart: '/vaccine-history?UptoDate=No record',
    filters: [
      {
        total_text: 'Total registered',
        total: 'AgeGroup=0-5',
        value: 'AgeGroup=0-5&UptoDate=No Record',
        link: '/vaccine-history?AgeGroup=0-5&UptoDate=No record',
        label: '0-5',
        custom_property_name_2: 'Age group',
        custom_property_value_2: '0-5',
        filtered_total_text: 'No Immunisation Record',
        filtered_total_value: '',
      },
      {
        total_text: 'Total registered',
        total: 'AgeGroup=6-19',
        value: 'AgeGroup=6-19&UptoDate=No Record',
        link: '/vaccine-history?AgeGroup=6-19&UptoDate=No record',
        label: '6-19',
        custom_property_name_2: 'Age group',
        custom_property_value_2: '6-19',
        filtered_total_text: 'No Immunisation Record',
        filtered_total_value: '',
      },
    ],
  },
  {
    title: 'Percentage of Children with Complete Vaccination Schedule',
    ref: 'dynamicArrayV4',
    summary_search_parameter_for_charts: 'UptoDate=Yes',
    main_link_for_chart: '/vaccine-history?UptoDate=Yes',
    filters: [
      {
        total_text: 'Total registered',
        total: 'AgeGroup=0-5',
        value: 'AgeGroup=0-5&UptoDate=Yes',
        link: '/vaccine-history?AgeGroup=0-5&UptoDate=Yes',
        label: '0-5',
        custom_property_name_2: 'Age group',
        custom_property_value_2: '0-5',
        filtered_total_text: 'Up to Date',
        filtered_total_value: '',
      },
      {
        total_text: 'Total registered',
        total: 'AgeGroup=6-19',
        value: 'AgeGroup=6-19&UptoDate=Yes',
        link: '/vaccine-history?AgeGroup=6-19&UptoDate=Yes',
        label: '6-19',
        custom_property_name_2: 'Age group',
        custom_property_value_2: '6-19',
        filtered_total_text: 'Up to Date',
        filtered_total_value: '',
      },
    ],
  },
  {
    title: 'Percentage of Children with Refusals',
    ref: 'dynamicArrayV4',
    summary_search_parameter_for_charts: 'HasRefusals=true',
    main_link_for_chart: '/vaccine-history?HasRefusals=true',
    filters: [
      {
        total_text: 'Total registered',
        total: 'AgeGroup=0-5',
        value: 'AgeGroup=0-5&HasRefusals=true',
        link: '/vaccine-history?AgeGroup=0-5&HasRefusals=true',
        label: '0-5',
        custom_property_name_2: 'Age group',
        custom_property_value_2: '0-5',
        filtered_total_text: 'Children with Refusals',
        filtered_total_value: '',
      },
      {
        total_text: 'Total registered',
        total: 'AgeGroup=6-19',
        value: 'AgeGroup=6-19&HasRefusals=true',
        link: '/vaccine-history?AgeGroup=6-19&HasRefusals=true',
        label: '6-19',
        custom_property_name_2: 'Age group',
        custom_property_value_2: '6-19',
        filtered_total_text: 'Children with Refusals',
        filtered_total_value: '',
      },
    ],
  },
];
